export const capitalizeString = (string) => {
  return String(string)
    .charAt(0)
    .toLocaleUpperCase()
    .concat(String(string).slice(1).toLowerCase());
};
